import React from 'react';
import {GreenKey, RedKey} from '../../assets/icons/icons';
import {
  BoxInfo,
  BoxLeft,
  BoxLeftHead,
  BoxLeftContent,
  BoxLeftInfo,
  BoxLeftValue,
  BoxLeftUnit,
  BoxRight,
  BoxRightHeader,
  BoxRightHeaderItem,
  BoxRightContent,
  BoxRuleWrapper,
  BoxRule,
  BoxRuleSpot,
  BoxRuleSpotValue,
  BoxRuleScale,
  BoxRuleScaleItem,
  BoxRightHeaderItemInfo,
  BoxRightHeaderItemSpecial,
  BoxLeftBottom,
} from './styles';

export default ({
  unit,
  ruler,
  title,
  symbol,
  result,
  previous,
  boxTitle,
  extraInfo,
  headerLeft = 'Previous: ',
  changeValue,
}: {
  unit: string;
  title: string;
  ruler?: string;
  symbol: string;
  result: number;
  previous: string;
  boxTitle?: string;
  extraInfo?: number;
  headerLeft?: string;
  changeValue: number | string | any;
}) => (
  <BoxInfo>
    {/* <span style={{display: 'none'}}>{(changeValue = -30)}</span> */}
    <BoxLeft>
      <BoxLeftHead>{title}</BoxLeftHead>
      <BoxLeftContent>
        <BoxLeftInfo>
          <BoxLeftValue>{result}</BoxLeftValue>
          <BoxLeftUnit>{boxTitle || unit}</BoxLeftUnit>
        </BoxLeftInfo>
      </BoxLeftContent>
      {Boolean(extraInfo) && (
        <BoxLeftBottom>
          <span>{extraInfo}</span>
          <span>7 Day Avg</span>
        </BoxLeftBottom>
      )}
    </BoxLeft>
    <BoxRight>
      <BoxRightHeader>
        <BoxRightHeaderItem>
          <span>{headerLeft}</span>
          <b>
            {previous} {unit}
          </b>
        </BoxRightHeaderItem>
        <BoxRightHeaderItem>
          <span>Change: </span>
          <BoxRightHeaderItemSpecial>
            {changeValue > 0 ? (
              <>
                <BoxRightHeaderItemInfo>
                  {'+' + changeValue} {symbol}
                </BoxRightHeaderItemInfo>
                <GreenKey />
              </>
            ) : changeValue === 0 || changeValue === '0.00' ? (
              <>
                <BoxRightHeaderItemInfo>
                  {changeValue} {symbol}
                </BoxRightHeaderItemInfo>
              </>
            ) : (
              <>
                <BoxRightHeaderItemInfo>
                  {changeValue} {symbol}
                </BoxRightHeaderItemInfo>
                <RedKey />
              </>
            )}
          </BoxRightHeaderItemSpecial>
        </BoxRightHeaderItem>
      </BoxRightHeader>
      <BoxRightContent>
        <BoxRuleWrapper>
          <BoxRuleSpot>
            {!changeValue.toString().includes('-') && changeValue < 5 && title === 'ROM' ? (
              <>
                EXCELLENT
                <BoxRuleSpotValue ruleColor="#7DDF73">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : changeValue.toString().includes('-') && changeValue > -5 && title === 'ROM' ? (
              <>
                EXCELLENT
                <BoxRuleSpotValue ruleColor="#7DDF73">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : !changeValue.toString().includes('-') && changeValue < 10 && title === 'ROM' ? (
              <>
                CAUTION
                <BoxRuleSpotValue ruleColor="#F7D366">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : changeValue.toString().includes('-') && changeValue > -10 && title === 'ROM' ? (
              <>
                CAUTION
                <BoxRuleSpotValue ruleColor="#F7D366">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : changeValue > -10 && title === 'ROM' ? (
              <>
                AT RISK
                <BoxRuleSpotValue ruleColor="#E66A4B">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : title === 'ROM' ? (
              <>
                AT RISK
                <BoxRuleSpotValue ruleColor="#E66A4B">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : changeValue > 0 && title !== 'ROM' ? (
              <>
                EXCELLENT
                <BoxRuleSpotValue ruleColor="#7DDF73">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : changeValue > 0 && title !== 'ROM' ? (
              <>
                EXCELLENT
                <BoxRuleSpotValue ruleColor="#7DDF73">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : changeValue === 0 && title !== 'ROM' ? (
              <>
                EXCELLENT
                <BoxRuleSpotValue ruleColor="#7DDF73">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : changeValue > -0.01 && title !== 'ROM' ? (
              <>
                CAUTION
                <BoxRuleSpotValue ruleColor="#F7D366">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : changeValue > -5 && title !== 'ROM' ? (
              <>
                CAUTION
                <BoxRuleSpotValue ruleColor="#F7D366">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : changeValue > -5.1 && title !== 'ROM' ? (
              <>
                AT RISK
                <BoxRuleSpotValue ruleColor="#E66A4B">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            ) : (
              <>
                AT RISK
                <BoxRuleSpotValue ruleColor="#E66A4B">
                  {Math.trunc(changeValue)}
                  {symbol}
                </BoxRuleSpotValue>
              </>
            )}
          </BoxRuleSpot>
          <BoxRule unit={ruler || unit} />
          <BoxRuleScale>
            <BoxRuleScaleItem>-15{symbol}</BoxRuleScaleItem>
            <BoxRuleScaleItem>-5{symbol}</BoxRuleScaleItem>
            <BoxRuleScaleItem>0{symbol}</BoxRuleScaleItem>
            <BoxRuleScaleItem>5{symbol}</BoxRuleScaleItem>
            <BoxRuleScaleItem>15{symbol}</BoxRuleScaleItem>
          </BoxRuleScale>
        </BoxRuleWrapper>
      </BoxRightContent>
    </BoxRight>
  </BoxInfo>
);
